// ==========================================
// PROPERTYSECTIONS.JSX - PROPERTY SECTIONS
// Estate Experts Real Estate Website
// Left Sidebar + Right Grid (3 columns)
// ==========================================

import React, { useContext, useEffect, useState } from "react";
import PropertyCard from "../PropertyCards/PropertyCards";
import "../../../../assets/css/Buyer/Properties/PropertyGrids.css";
import AppContext from "context/AppContext";
import axios from "axios";
import { Col, Row } from "react-bootstrap";
import { properties } from "../propertyId/Property";

function PropertyGrids() {
  // ==========================================
  // STATE MANAGEMENT
  // ==========================================

  const { baseUrl ,authToken} = useContext(AppContext);
  
  // Active filter - 'Buy' or 'Rent'
  const [activeFilter, setActiveFilter] = useState("For Sale");
  
  // All properties from API
  const [allProperties, setAllProperties] = useState([]);
  
  // Active category filter
  const [activeCategory, setActiveCategory] = useState("House");
  
  // Show more state
  const [showMore, setShowMore] = useState(false);

  // ==========================================
  // FETCH PROPERTIES FROM API
  // ==========================================

 const viewAllBuyerProperty = () => {
    const formData = new FormData();

    formData.append("listingType", activeFilter);
    formData.append("property_type", activeCategory);

    axios.post(`${baseUrl}/buyer/property/viewAllBuyerProperty`, formData, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
        .then((response) => {
            setAllProperties(response.data.property);
        })
        .catch((error) => {
            console.log(error);
        });
};
useEffect(() => {
    viewAllBuyerProperty();
}, [activeFilter, activeCategory]);


 
  // ==========================================
  // CATEGORIES LIST
  // ==========================================

  const categories = [
    { id: "House", name: "House" },
    { id: "Apartment", name: "Apartment" },
    { id: "Villa", name: "Villa" },
    { id: "Plot", name: "Plot" },
    { id: "Commercial", name: "Commercial" },
    { id: "Farm House", name: "Farm House" }
  ];



  // ==========================================
  // RENDER
  // ==========================================

  return (
    <section className="property-sections">
      <div className="sections-container">
        
        {/* ==========================================
            BUY/RENT TOGGLE FILTER
            ========================================== */}
        <div className="filter-toggle">
          <button
            className={`toggle-btn ${activeFilter === "For Sale" ? "active" : ""}`}
            onClick={() => {
              setActiveFilter("For Sale");
              
              setShowMore(false);
            }}
          >
            Sell
          </button>
          <span className="toggle-divider">|</span>
          <button
            className={`toggle-btn ${activeFilter === "For Rent" ? "active" : ""}`}
            onClick={() => {
              setActiveFilter("For Rent");
              
              setShowMore(false);
            }}
          >
            Rent
          </button>
        </div>

        {/* ==========================================
            MAIN LAYOUT - SIDEBAR + GRID
            ========================================== */}
        <div className="property-section">
          <Row>
            
            {/* LEFT SIDEBAR - 3 Columns */}
            <Col md={3}>
              <div className="property-sidebar">
                <h3 className="sidebar-title">Categories</h3>
                <ul className="category-list">
                  {categories.map((category) => (
                    <li
                      key={category.id}
                      className={`category-item ${activeCategory === category.id ? "active" : ""}`}
                      onClick={() => {
                        setActiveCategory(category.id);
                       
                        setShowMore(false);
                      }}
                    >
                      <span className="category-name">{category.name}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>

            {/* RIGHT CONTENT - 9 Columns */}
            <Col md={9}>
              <h2 className="section-heading">
                {activeCategory === "all" 
                  ? "All Properties" 
                  : categories.find(c => c.id === activeCategory)?.name || "Properties"
                }
              </h2>

              {/* Property Grid - 3 columns */}
              <div className="property-grid">
                {allProperties.length > 0 ? (
                  allProperties.map((property) => (
                    <PropertyCard key={property.id} property={property} />
                  ))
                ) : (
                  <div className="empty-state">
                    <h3>No Properties Found</h3>
                    <p>Try selecting a different category or filter.</p>
                  </div>
                )}
              </div>

              {/* Load More Button */}
              {allProperties.length > 6 && !showMore && (
                <div className="load-more-container">
                  <button
                    className="load-more-btn"
                    onClick={() => setShowMore(true)}
                  >
                    Load More
                  </button>
                </div>
              )}
            </Col>

          </Row>
        </div>

      </div>
    </section>
  );
}

export default PropertyGrids;